import { gql } from '@apollo/client'

const dfmFeedbackQuery = gql`
    query dfmFeedbackQuery($name: String!) {
        salesOrder(name: $name) {
            salesOrderLines(limit: 100) {
                items {
                    id
                    quoteModelRevision {
                        id
                        dfmFeedback(includeDraft: true) {
                            id
                            isPublished
                        }
                    }
                }
                parts {
                    id
                    quoteModelRevision {
                        id
                        dfmFeedback(includeDraft: true) {
                            id
                            isPublished
                        }
                    }
                }
            }
        }
    }
`

export default dfmFeedbackQuery
